import type { Asset, CombinedAsset } from '@/types';

export function isBaseAsset(asset: Asset): boolean {
  return asset.baseAsset.name === asset.name && !asset.isCombined;
}

export function isTestnetAsset(asset: Asset): boolean {
  return Boolean(asset.baseAsset.api?.features?.isTestnet);
}

export function isCombinableAsset(asset: Asset): asset is CombinedAsset {
  return asset.assetType === 'MULTI_NETWORK_ASSET';
}
